import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { get } from 'lodash'

function ConfigureHelmet (props) {
  let faviconUrl = get(props, 'clientConfig.favicon', '')
  let title = get(props, 'clientConfig.siteName', '')

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        {title && <title>{title}</title>}
        {faviconUrl && (
          <link rel='shortcut icon' id='favicon' href={faviconUrl} />
        )}
      </Helmet>
    </>
  )
}

export default connect(state => {
  const { CLIENT_CONFIG_SUCCESS, CLIENT_CONFIG_LOADING } = state

  return {
    ...CLIENT_CONFIG_SUCCESS,
    ...CLIENT_CONFIG_LOADING
  }
}, {})(ConfigureHelmet)
